function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import { accessor, constant } from "d3plus-common";
import Shape from "./Shape";
/**
    @class Rect
    @extends Shape
    @desc Creates SVG rectangles based on an array of data. See [this example](https://d3plus.org/examples/d3plus-shape/getting-started/) for help getting started using the rectangle generator.
*/

var Rect =
/*#__PURE__*/
function (_Shape) {
  _inherits(Rect, _Shape);

  /**
      @memberof Rect
      @desc Invoked when creating a new class instance, and overrides any default parameters inherited from Shape.
      @private
  */
  function Rect() {
    var _this;

    _classCallCheck(this, Rect);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Rect).call(this, "rect"));
    _this._height = accessor("height");

    _this._labelBounds = function (d, i, s) {
      return {
        width: s.width,
        height: s.height,
        x: -s.width / 2,
        y: -s.height / 2
      };
    };

    _this._name = "Rect";
    _this._width = accessor("width");
    return _this;
  }
  /**
      @memberof Rect
      @desc Draws the rectangles.
      @param {Function} [*callback*]
      @chainable
  */


  _createClass(Rect, [{
    key: "render",
    value: function render(callback) {
      _get(_getPrototypeOf(Rect.prototype), "render", this).call(this, callback);

      var enter = this._enter.attr("width", 0).attr("height", 0).attr("x", 0).attr("y", 0).call(this._applyStyle.bind(this));

      var update = this._update;

      if (this._duration) {
        enter = enter.transition(this._transition);
        update = update.transition(this._transition);

        this._exit.transition(this._transition).attr("width", 0).attr("height", 0).attr("x", 0).attr("y", 0);
      }

      enter.call(this._applyPosition.bind(this));
      update.call(this._applyStyle.bind(this)).call(this._applyPosition.bind(this));
      return this;
    }
    /**
        @memberof Rect
        @desc Given a specific data point and index, returns the aesthetic properties of the shape.
        @param {Object} *data point*
        @param {Number} *index*
        @private
    */

  }, {
    key: "_aes",
    value: function _aes(d, i) {
      return {
        width: this._width(d, i),
        height: this._height(d, i)
      };
    }
    /**
        @memberof Rect
        @desc Provides the default positioning to the <rect> elements.
        @param {D3Selection} *elem*
        @private
    */

  }, {
    key: "_applyPosition",
    value: function _applyPosition(elem) {
      var _this2 = this;

      elem.attr("width", function (d, i) {
        return _this2._width(d, i);
      }).attr("height", function (d, i) {
        return _this2._height(d, i);
      }).attr("x", function (d, i) {
        return -_this2._width(d, i) / 2;
      }).attr("y", function (d, i) {
        return -_this2._height(d, i) / 2;
      });
    }
    /**
        @memberof Rect
        @desc If *value* is specified, sets the height accessor to the specified function or number and returns the current class instance.
        @param {Function|Number} [*value*]
        @chainable
        @example
    function(d) {
    return d.height;
    }
    */

  }, {
    key: "height",
    value: function height(_) {
      return arguments.length ? (this._height = typeof _ === "function" ? _ : constant(_), this) : this._height;
    }
    /**
        @memberof Rect
        @desc If *value* is specified, sets the width accessor to the specified function or number and returns the current class instance.
        @param {Function|Number} [*value*]
        @chainable
        @example
    function(d) {
    return d.width;
    }
    */

  }, {
    key: "width",
    value: function width(_) {
      return arguments.length ? (this._width = typeof _ === "function" ? _ : constant(_), this) : this._width;
    }
  }]);

  return Rect;
}(Shape);

export { Rect as default };